<template>
  <div class="main-app-content">
    <!-- TO THE TOP BUTTON ================================================== -->
    <a
      id="back-to-top"
      href="#top"
      class="btn btn-primary back-to-top"
      role="button"
      title="Click to return on the top page"
      data-toggle="tooltip"
      data-placement="left"
    >
      <i class="ion-android-arrow-up"></i>
    </a>
    <Navbar></Navbar>
    <div id="top"></div>

    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <Footer></Footer>
  </div>
</template>

<script>
import CustomJS from "./utils/custom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
export default {
  components: { Footer, Navbar },
  mounted() {
    CustomJS.init();
  }
};
</script>

<style lang="scss">
.main-app-content {
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.25s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0.9;
}
</style>
